import { Component, OnInit } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdLoadingService, TdDataTableService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { CollectionService } from '../../../shared/services/collection.service';
import { SupplierService } from '../suppliers/supplier.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-collections-list',
  templateUrl: './collections-list.component.html',
  styleUrls: ['./collections-list.component.scss'],
  providers: [CollectionService]
})
export class CollectionsListComponent implements OnInit {
  data: any[];

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Collection name' },
    { name: 'supplier_id', label: 'Supplier' },
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  
  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: MdDialog,
    private _loadingService: TdLoadingService,
    private _collectionService: CollectionService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService) { }

  ngOnInit() {
    this._loadingService.register('loading');
    
    this._collectionService.getCollections().subscribe(
      response => {
        console.log(response);
        this.data = response;
      },
      error => {
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');        
        this.filter();
      }
    );
  }

  openAddNewCollectionDialog() {
    this._dialogService.open(NewCollectionDialog).afterClosed().subscribe(
      result => {
        if (result != null) {
          this.data.push(result);
          this.filter();
        }
      }
    );
  }

  deleteSelected() {
    this._loadingService.register('loading');
    
    this.selectedRows.forEach(
      (collection) => {
        this._collectionService.removeCollection(collection.id).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.data = this.data.filter( function(c) { return c['id'] != response['id'] } );
            } else {
              console.log('Could not delete ' + collection.name);
            }
          },
          error => {
            console.log(error);
          },
          () => {
            this._loadingService.resolve('loading');
            
            this.filter();
          }
        );
      }
    );

    this.selectedRows = [];
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}


@Component({
  selector: 'new-collection-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <h4>Enter new collection name and supplier</h4>
      <md-divider></md-divider>
      <md-input-container>
        <input mdInput type="text" placeholder="Collection Name" [(ngModel)]="name">
      </md-input-container>
      <md-select fxFlex="22%" placeholder="Supplier" [(ngModel)]="supplier_id">
        <md-option *ngFor="let supplier of suppliers" [value]="supplier.id">{{supplier.name}}</md-option>
      </md-select>
      <div flex layout="row" layout-wrap>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="addCollection()">Add</button>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="dialogRef.close()">Close</button>
      </div>
    </div>
  `,
})
export class NewCollectionDialog implements OnInit {
  suppliers: any[] = [];

  name: string = '';
  supplier_id: number = 0;

  constructor(public dialogRef: MdDialogRef<NewCollectionDialog>,
    private tdDialog: TdDialogService,
    private _collectionService: CollectionService,
  private _supplierService: SupplierService) { }

  ngOnInit() {
    this._supplierService.getSuppliers().subscribe(
      response => {
        console.log(response);
        this.suppliers = response;
      },
      error => {
        console.log(error)
      },
      () => { }
    );
  }

  addCollection() {
    this._collectionService.addCollection({ name: this.name, supplier_id: this.supplier_id }).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'City added successfully'
            }
          );
          this.dialogRef.close({ name: this.name, supplier_id: this.supplier_id });
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add city'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );

  }
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/collections-list/collections-list.component.ts